import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import { noticeError } from 'app/api/analytics/reporting';
import { importFirst } from '../utils/async';

export let localizedHumanizer = humanizeDuration;

export async function localizeModules(locale) {
  locale = locale
    .split('_')
    .join('-')
    .toLowerCase();
  const lang = locale.split('-')[0];

  if (locale !== 'en') {
    try {
      const { index } = await importFirst([
        () => import(`moment/locale/${locale}`),
        () => import(`moment/locale/${lang}`),
      ]);
      moment.locale(index === 0 ? locale : lang);
    } catch (e2) {
      noticeError(`MomentJS not available for locale ${locale}`);
    }
  } else {
    moment.locale('en');
  }

  const langs = humanizeDuration.getSupportedLanguages();
  if (langs.indexOf(lang) !== -1) {
    localizedHumanizer = humanizeDuration.humanizer({
      language: lang,
    });
  } else {
    noticeError(`HumanizeDuration not available for locale ${locale}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/localize-modules.js